import React from "react";
import PropTypes from "prop-types";
import {connect} from "react-redux";
import {siblingProductsSelector} from "../../ducks/product";
import withErrorBoundary from "../../../../decorators/withErrorBoundary";
import ProductCards from "../../../common/ProductCards";

function SiblingProducts(props) {
  const {siblingProducts} = props;
  return (
    <ProductCards title="Еще от этого дизайнера" products={siblingProducts} />
  );
}

SiblingProducts.propTypes = {
  siblingProducts: PropTypes.array
};

const mapStateToProps = (state) => ({
  siblingProducts: siblingProductsSelector(state)
});

export default connect(mapStateToProps)(withErrorBoundary(SiblingProducts));
